import React from 'react';
import TablesManager from '../components/tables/TablesManager';

// No page title here: the grid header (area name + floor pulse + actions) is the
// single bar of chrome — tables start as high as possible.
const Tables: React.FC = () => <TablesManager />;

export default Tables;
